import React from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";

function Photel() {
  useDocumentTitle("Pajak Hotel- BAPENDA BEKASI");
  return (
    <div className="page">
      <Header active="Photel" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pelayanan / Pajak Hotel" />
          <div className="page-title-wrapper">
            <div className="page-title">PBJT ATAS JASA PERHOTELAN</div>
          </div>

          {/* <p className="page-text">
            Dalam rangka pelaksanaan Peraturan Pemerintah Nomor 18 Tahun 2016 tentang Perangkat Daerah dan Peraturan Menteri Dalam Negeri Nomor 97 Tahun 2016 tentang Perangkat Daerah Provinsi DKI Jakarta, maka berdasarkan Peraturan Gubernur
            Nomor 154 Tahun 2020 tentang Organisasi dan Tata Kerja Perangkat Daerah dibentuklah Badan Pendapatan Daerah (Bapenda) Provinsi DKI Jakarta.
          </p> */}

          <p className="subpage-title"><strong>PBJT Atas Jasa Perhotelan</strong></p>
          <p className="page-text">PBJT Atas Jasa Perhotelan adalah jasa penyediaan akomodasi yang dapat dilengkapi
dengan jasa pelayanan makan dan minum, kegiatan hiburan, dan/atau
fasilitas lainnya.Jasa Hotel termasuk dalam jenis Pajak Barang dan Jasa Tertentu yang selanjutnya disingkat PBJT adalah Pajak yang dibayarkan oleh konsumen akhir atas konsumsi barang dan/atau jasa tertentu. Barang dan Jasa Tertentu adalah barang dan jasa tertentu yang dijual
dan/atau diserahkan kepada konsumen akhir.</p>
<p>
Jasa Perhotelan meliputi jasa penyediaan akomodasi dan fasilitas penunjangnya, serta penyewaan
ruang rapat/pertemuan pada penyedia jasa perhotelan seperti:<br></br>
a. hotel;<br></br>
b. hostel;<br></br>
c. vila;<br></br>
d. pondok wisata;<br></br>
e. motel;<br></br>
f. losmen;<br></br>
g. wisma pariwisata;<br></br>
h. pesanggrahan;<br></br>
i. rumah penginapan/guesthouse/bungalo/resort/cottage;<br></br>
j. tempat tinggal pribadi yang difungsikan sebagai hotel;<br></br>
k. glamping
<p></p>


<br></br>
<p className="page-text"><strong>
Dasar pengenaan PBJT adalah jumlah yang dibayarkan oleh konsumen
barang atau jasa tertentu, meliputi:</strong> <br></br>
a. jumlah pembayaran kepada penyedia Jasa Perhotelan untuk PBJT atas
Jasa Perhotelan;<br></br>
b. Dalam hal pembayaran menggunakan voucer atau bentuk lain yang sejenis yang memuat nilai rupiah atau mata
uang lain, dasar pengenaan PBJT ditetapkan sebesar nilai rupiah atau
mata uang lainnya tersebut;<br></br>
c. Dalam hal tidak terdapat pembayaran, dasar pengenaan PBJT dihitung berdasarkan harga jual barang dan
jasa sejenis yang berlaku di wilayah Daerah.
<br></br>

<strong>Tarif PBJT atas Jasa Perhotelan ditetapkan sebesar 10% (sepuluh persen)</strong>
</p>

<br></br>
<p className="page-text"><strong>
DASAR HUKUM : </strong><br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>

</p>
         
        
         
         
          
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default Photel;
